import { render } from "./WrongGuessedLetters.vue?vue&type=template&id=fc1a3462"
import script from "./WrongGuessedLetters.vue?vue&type=script&lang=ts"
export * from "./WrongGuessedLetters.vue?vue&type=script&lang=ts"
script.render = render

export default script